import Immutable from "immutable";
import recordMerger from "services/record-merger";

export class TagRecord extends Immutable.Record({
  id: null,
  client: null,
  color: null,
  name: null
}) {}

let tagIndex;
let lastSavedTags;

/**
 * @param {Immutable.List} list
 * @param {String} id
 * @returns {Number}
 */
function getTagIndex(list, id) {
  return list.findIndex(listItem => listItem.id === id);
}

const initialState = Immutable.List();

export const tags = (state = initialState, action) => {
  let nextState = state;

  switch (action.type) {
    case "SET_TAG":
      tagIndex = getTagIndex(state, action.payload.id);

      return state.mergeIn([tagIndex], action.payload);
    case "UPDATE_TAG_SUCCESS":
      tagIndex = getTagIndex(nextState, action.response.data.tag._id);
      nextState = nextState.mergeIn(
        [tagIndex], recordMerger(action.response.data.tag, new TagRecord())
      );
      lastSavedTags = nextState;

      return nextState;
    case "UPDATE_TAG_FAILURE":
      tagIndex = getTagIndex(state, action.tagId);

      return state.setIn([tagIndex], lastSavedTags.getIn([tagIndex]));
    case "GET_TAGS_SUCCESS":
      nextState = nextState.clear();
      action.response.data.tags.forEach((tag) => {
        const newTag = new TagRecord(recordMerger(tag, new TagRecord()));
        nextState = nextState.push(newTag);
      });
      lastSavedTags = nextState;

      return nextState;
    case "GET_TAGS_FAILURE":
      console.warn("Failed to get tags");

      return nextState;

    case "CREATE_TAG_SUCCESS": {
      const newTag = new TagRecord(recordMerger(action.response.data.tag, new TagRecord()));
      nextState = nextState.push(newTag);
      lastSavedTags = nextState;

      return nextState;
    }

    case "DELETE_TAG_SUCCESS":
      nextState = nextState.filter(tag => tag.id !== action.response.data.tag._id);
      lastSavedTags = nextState;

      return nextState;
    default:
      return nextState;
  }
};
